import React from "react";
import { DateTimeIcon, TimeIcon } from "../../icon";
import { PickerMode, PICKER_MODE } from "../constants";

interface PickerIconProps {
  mode: PickerMode;
}

export const PickerIcon: React.FC<PickerIconProps> = ({ mode }) => {
  const IconComponent = mode === PICKER_MODE.DATE ? DateTimeIcon : TimeIcon;
  
  return (
    <IconComponent
      w="2.5rem"
      h="2.5rem"
      color="#525252"
      zIndex={10}
      {...(mode === PICKER_MODE.TIME && { fontSize: "1rem" })}
    />
  );
};
